<template>
  <div class="container">
    <transition name="fade" mode="out-in">
      <pro-list v-if="hasMultipleProfiles && !profileId" />
      <create-review v-else-if="profileId" />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

import workOrder from '@/mixins/work-order';
import authWithToken from '@/mixins/auth-token';
import reviewParams from '@/mixins/review-params';
import ProList from './components/ProList';
import CreateReview from './components/CreateReview';

export default {
  name: 'new-review',
  components: {
    ProList,
    CreateReview,
  },
  mixins: [
    workOrder,
    authWithToken,
    reviewParams,
  ],
  data () {
    return {
      jobsBucketName: 'createReview',
    };
  },
  computed: {
    ...mapState('propublicprofile', [
      'profiles',
    ]),
    ...mapGetters('user', [
      'isPro',
      'isLoggedIn',
    ]),
    hasProfiles () {
      return this.skillsProfiles.length > 0;
    },
    hasMultipleProfiles () {
      return this.skillsProfiles.length > 1;
    },
  },
  async mounted () {
    if (!this.isLoggedIn || this.isPro) {
      await this.authenticateWithToken(this.token);
    }

    if (this.skillsProfiles.length) {
      if (!this.workOrder) {
        await this.fetchWorkOrder({ jobId: this.jobId, includePublicProfiles: true });
      }
      await this.fetchProfiles({ serviceProviderOccupationIds: this.skillsProfiles });
    }

    if (this.hasProfiles && !this.hasMultipleProfiles && this.profiles.length) {
      const { identifier } = this.profiles[0].service_provider;
      this.$router.replace({
        name: 'consumer::reviews::new',
        query: {
          ...this.$route.query,
          [this.$options.REVIEWS_QUERY_PARAMS.PROFILE_ID]: identifier,
        },
      });
    }
  },
  methods: {
    ...mapActions('propublicprofile', [
      'fetchProfiles',
    ]),
  },
};
</script>
